import React from 'react'
import ReactDom from 'react-dom'
import UnitMapPanel from './UnitMapPanel'
import {
  hilightElement,
  hilightLevel,
  hilightHitArea,
  hilightUnit
} from '../actions'

class Sightmap extends React.Component {

  constructor(props) {
    super(props)

    this.handleUnitMap = this.handleUnitMap.bind(this)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.config !== this.props.config
    || nextProps.currentFloor !== this.props.currentFloor
    || nextProps.document !== this.props.document
    || nextProps.height !== this.props.height
    || nextProps.highlightedUnit !== this.props.highlightedUnit
    || nextProps.units !== this.props.units
  }

  handleUnitMap(event) {
    if (this.props.onUnitMap) {
      this.props.onUnitMap(event)
    }
  }

  render() {
    const {
      config,
      currentFloor,
      displayDocumentErrors,
      documentBackgroundColor,
      document,
      height,
      highlightedUnit,
      units
    } = this.props

    let unitsJS = units.toJS()

    return (
      <div id="sitemap-container" style={{height}}>
        <div id="sitemap">
          <UnitMapPanel
            backgroundColor={documentBackgroundColor}
            config={config}
            currentFloor={currentFloor}
            document={document}
            height={height}
            highlightedUnit={highlightedUnit}
            onUnitMap={this.handleUnitMap}
            onUnitClick={this.props.onUnitClick}
            onUnitOver={this.props.onUnitOver}
            units={unitsJS} />
        </div>
      </div>
    )
  }
}

export default Sightmap
